import { autoinject, metadata } from 'aurelia-framework';
import { ViewResources } from 'aurelia-templating';
import { Constructor } from '../interfaces/constructor';
import { WIDGET_METADATA_KEY } from '../widgets/widget-decorator';
import { IWidgetMetadata } from '../widgets/i-widget-metadata';
import { PROPERTIES_METADATA_KEY } from '../widgets/property-decorator';
import { IPropertyMetadata } from '../widgets/i-property-metadata';

declare module 'aurelia-templating' {
  interface ViewResources {
    elements: Record<string, HtmlBehaviorResource>;
    parent: ViewResources;
  }

  interface HtmlBehaviorResource {
    target: Constructor<unknown>;
  }
}

@autoinject
export class WidgetService {
  constructor(private viewResources: ViewResources) { }

  private _availableWidgets: IWidgetMetadata[];
  get availableWidgets(): IWidgetMetadata[] {
    if (!this._availableWidgets) {
      this._availableWidgets = Object.keys(this.viewResources.elements).map(x => {
        const viewModel = this.viewResources.elements[x].target;
        return metadata.getOwn(WIDGET_METADATA_KEY, viewModel) as IWidgetMetadata;
      }).filter(x => !!x && (x.canUseInDashboard || x.canUseInReport)).sort((a, b) => a.name.localeCompare(b.name));
    }
    return this._availableWidgets;
  }
}

export function getWidgetPropertiesMetadata(widgetClass: Function): IPropertyMetadata[] {
  const props = metadata.getOwn(PROPERTIES_METADATA_KEY, widgetClass) as IPropertyMetadata[] ?? [];
  const baseProps = metadata.getOwn(PROPERTIES_METADATA_KEY, Object.getPrototypeOf(widgetClass)) as IPropertyMetadata[] ?? [];
  const baseBaseProps = metadata.getOwn(PROPERTIES_METADATA_KEY, Object.getPrototypeOf(Object.getPrototypeOf(widgetClass))) as IPropertyMetadata[] ?? [];
  return [...baseBaseProps ?? [], ...baseProps, ...props];
}
